export default __webpack_public_path__ + "static/ux-ui-hero-2-945313b7ae0962175276ef1059a564a1.png";